import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, firstValueFrom } from 'rxjs';
import { getMcpRolloutBatchFlag } from 'src/app/app/app.constants';
import { GrowthBookService } from 'src/app/services/growthbook/service';
import { AuthState } from 'src/app/store/auth/auth.state';

export function mcpEnabledGuard(redirectTo: string): CanActivateFn {
  return async (_route, _state) => {
    const store = inject(Store);
    const growthbook = inject(GrowthBookService);
    const router = inject(Router);

    await firstValueFrom(growthbook.initialized.pipe(filter((x) => x)));

    const company = store.selectSnapshot(AuthState.company);
    const batchFlag = company?.id ? getMcpRolloutBatchFlag(company.id) : undefined;

    if (batchFlag && growthbook.getFeatureValue<boolean>(batchFlag, false)) {
      return true;
    }

    if (growthbook.getFeatureValue<boolean>('mcp-enabled', false)) {
      return true;
    }

    return router.createUrlTree([redirectTo]);
  };
}
